import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from './../firebase/firebaseConfig';

export default function EmailVerified() {
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const mode = searchParams.get('mode');
    const actionCode = searchParams.get('oobCode');

    if (mode === 'verifyEmail' && actionCode) {
      console.log('Mode:', mode);
      console.log('Action Code:', actionCode);
      handleEmailVerification(actionCode);
    }
  }, [searchParams]);

  const handleEmailVerification = async (actionCode) => {
    try {
      await applyActionCode(auth, actionCode);
      console.log('Email verification successful');
      setVerificationStatus('success');
    } catch (error) {
      console.error('Error verifying email:', error);
    }
  };

  const renderMessage = () => {
    return (
      <>
        <h1 className="unbounded fw-bold" style={{ fontSize: '50px', textTransform: 'uppercase' }}>
          Email Verified
        </h1>
        <h6 style={{ fontSize: '20px' }}>
          <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path>
          </svg>
          <b>Your email was verified successfully</b>
        </h6>
        <Link to="/sign-in" className="black-button">
          Sign In
        </Link>
      </>
    );
  };

  return (
    <div className="d-flex justify-content-center flex-column align-self-center px-3" style={{ position: 'fixed', margin: '30vh auto' }}>
      {verificationStatus === 'success' && renderMessage()}
    </div>
  );
}
